// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2EY2qji6Kks9_DZw0927R9"};